import { render, staticRenderFns } from "./ColorModuleHeader.vue?vue&type=template&id=fc1d70d4&scoped=true"
import script from "./ColorModuleHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorModuleHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorModuleHeader.vue?vue&type=style&index=0&id=fc1d70d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1d70d4",
  null
  
)

export default component.exports